const isProduction = process.env.VUE_APP_ENV_NAME === 'production';
const devMenuId = ['9781', '9781', '0099'];
const proMenu = ['9781', '9781', '0099'];
export interface NewsItemTypes {
  id: number;
  classId: number;
  title: string;
  dataType: number;
  showType: number;
  publishTime: string;
  lastDoTime: number;
  imageUrl: string[];
  isVideo: number;
  videoUrl: string;
  videoTime: string;
  doLikeNum: number;
  isDoLike: number;
  isTop: number;
  label: string;
  plNum: string;
  interactNum: string;
  isAd: number;
  pv: string;
  imageNum: number;
  category: string;
  targetUrl: string;
  sourceImage: string;
  sourceName: string;
  smallText: string;
  traceInfo: string;
  traceId: string;
  contentLength: number;
  adId: number;
  buryValue: string;
  pcUrl: string;
}
export const getChannelList = () => {
  const ids = isProduction ? proMenu : devMenuId;
  return ids;
};